module.exports = __webpack_public_path__ + "static/media/room.df01527a.jpg";